document.addEventListener('DOMContentLoaded', () => {
  // Only run this code if we're on the app redirect page and not in test environment
  if (document.getElementById('redirect-message') && process.env.NODE_ENV !== 'test') {
    const STORE_URLS = {
      ios: document.querySelector('meta[name="app-store-url"]').content,
      android: document.querySelector('meta[name="play-store-url"]').content,
      desktop: document.querySelector('meta[name="desktop-url"]').content,
    };

    const userAgent = navigator.userAgent;

    const deviceType = /iPad|iPhone|iPod/.test(userAgent) ? 'ios' : /Android/.test(userAgent) ? 'android' : 'desktop';
    
    window.location.href = STORE_URLS[deviceType];
  }
});